// Recuperer les info de l'instance pour certains champs
const userInfo = JSON.parse(localStorage.getItem("user"));

// Nom du user pour remplir representative
const userName = `${userInfo?.firstname} ${userInfo?.lastname}`

const emptyDataABE_10_40 = {
  id: null,
  UserId: null,
  productName: "ABE-10-40",
  productId: "6",
  quoteCode: null,
  projectCode: null,
  quoteDate: null,
  isActive: true,
  quotationStatus: "Active",
  estimativeShippingDate: new Date(),
  unitaryPriceCDN: null,
  unitaryPriceUSD: null,
  numberUnits: 1,
  exchangeRate: null,
  unitsTag: null,
  representative: userName,
  ///////////// CHAMPS PROPRE À ABE-10-40 /////////////
  location: "Indoor",
  arrangement: 'Horizontal',
  voltage: "575/3/60",
  elevation: 0,
  accessControl: "Left",
  airFlowType: "Constant",
  supplyAirHighVolume: null,
  supplyAirMinVolume: 0,
  supplyAirESP: 1,
  returnAirHighVolume: null,
  returnAirMinVolume: 0,
  returnAirESP: 1,
  motorOversizeFactor: "1.1",
  winterConditionsOutdoorTdB: "-20",
  winterConditionsOutdoorTwB: "-20",
  winterConditionsOutdoorRH: "",
  winterConditionsReturnTdB: "70",
  winterConditionsReturnTwB: "52",
  winterConditionsReturnRH: "",
  summerConditionsOutdoorTdB: "90",
  summerConditionsOutdoorTwB: "75",
  summerConditionsOutdoorRH: "",
  summerConditionsReturnTdB: "75",
  summerConditionsReturnTwB: "59",
  summerConditionsReturnRH: "",
  accuCore: "90% +",
  oaeaDamper: 'Uninsulated',
  finish: 'Galvanized steel',
  material: "Desiccant",
  controls: "Local Mode",
  communication: "MSTP",
  filtersType: "MERV 8",
  filtersLevel: "Mid",
  mERVFreshReturnAirFilters: null,
  roofCurb: 'Not Included',
  ////////////////////////////////////////////////
  shipping: "Not Included",
  country: null,
  province: null,
  city: null,
  startUp: "Not Included",
  unitModel: null,
  mechanicalCode: null,
  curbDrawing: null,
  electricalDiagram: null,
  unitaryPrice: null,
  unitaryShippingPrice: null,
  unitaryStartUpPrice: null,
  totalUnitaryPrice: null,
  isPriceValid: false,
  userCreation: null,
  dateCreation: new Date(),
  userModification: null,
  projectNumber: null,
  dateModification: new Date(),
  margin: 0,
  voltage: "575/3/60", 
};

export default emptyDataABE_10_40;

